import { Modal, Section, Button } from '@casanova/casanova-common';
import { useCallback } from 'react';
import moment from 'moment';
import { ISO_DATE_FORMAT, MX_DATE_FORMAT } from 'utils/constants';
import styles from './styles.module.css';

const ViewExpiringContracts = (props) => {
  const { show = true, setShow, data = {}, downloadReports } = props;
  const { title, contracts = [] } = data;
  const handleCloseModal = useCallback(() => {
    setShow(false);
  }, [setShow]);

  const handleDownloadReport = useCallback(() => {
    downloadReports({
      params: {
        params: [],
        reportType: 'b3ad171b-8416-4a7f-a56a-071ece08853f',
      },
    });
  }, []);

  return (
    <>
      <Modal
        open={show}
        header={null}
        footer={null}
        className="ViewRefundDetail"
        contentClassName="px-4 py-4 container"
        closeButton
        onClose={handleCloseModal}
        bigModal
      >
        <Section
          title={title}
          right={
            title === 'Contratos vencidos' ? (
              <Button onClick={handleDownloadReport}>
                Descargar reporte de contratos vencidos
              </Button>
            ) : null
          }
        >
          <div className={`container-fluid ${styles.contractContainer}`}>
            <div className="row">
              <div className="col-12">
                <div className={styles.contractGrid}>
                  {contracts.map((contract) => (
                    <div key={contract} className="card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Contrato #{contract.contractNumber}
                        </h5>
                        {/* <p className="card-text">
                          Número de Reservación: {contract.numeroReservacion}
                        </p> */}
                        <p className="card-text">
                          Cliente: {contract.customer}
                        </p>
                        <p className="card-text">
                          Fecha de Vencimiento:{' '}
                          {moment(
                            contract.returnDateTime,
                            ISO_DATE_FORMAT
                          ).format(MX_DATE_FORMAT)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Section>
      </Modal>
    </>
  );
};

export default ViewExpiringContracts;
